import { Transaction, xdr } from '@stellar/stellar-sdk';

// Simulation supplies resources and fees, never additional spending authority.
export const assertSwapAuthorization = (tx: Transaction, source: string, expected: string) => {
    const operation = tx.operations[0];
    const expectedInvoke = xdr.Operation.fromXDR(expected, 'base64').body().invokeHostFunctionOp();
    if (
        tx.source !== source ||
        tx.operations.length !== 1 ||
        operation.type !== 'invokeHostFunction' ||
        (operation.source && operation.source !== source) ||
        operation.func.toXDR('base64') !== expectedInvoke.hostFunction().toXDR('base64') ||
        JSON.stringify(operation.auth.map(entry => entry.toXDR('base64'))) !==
            JSON.stringify(expectedInvoke.auth().map(entry => entry.toXDR('base64')))
    ) {
        throw new Error('Swap authorization changed. Please try again.');
    }
};

export const getSwapResult = (result: xdr.ScVal, withTrustline: boolean): xdr.ScVal => {
    if (!withTrustline) return result;
    if (result.switch().name !== 'scvVec') {
        throw new Error('Unexpected swap result. Check the transaction in the explorer.');
    }
    const values = result.vec();
    if (
        values.length !== 2 ||
        values[0].switch().name !== 'scvVoid' ||
        values[1].switch().name !== 'scvU128'
    ) {
        throw new Error('Unexpected swap result. Check the transaction in the explorer.');
    }
    return values[1];
};
